import * as e from "react";
import { spinnerDefaultProps as c } from "./props.js";
import { cls as d } from "../../helpers/cls.js";
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const p = '\xC9 necess\xE1rio informar o atributo "aria-label" para garantir acessibilidade para leitores de tela.',
  n = 44,
  i = 3.52,
  _ = 22 - i / 2,
  m = "22 22 44 44",
  E = _ref => {
    let {
      "aria-label": r,
      color: o = c.color,
      inverted: t,
      size: a,
      className: l
    } = _ref;
    if (r === void 0 || r === "") throw new Error(p);
    const s = t ? "var(--color-neutral-70)" : "var(".concat(o, ")");
    return e.createElement("div", {
      className: d("olx-spinner", a && "olx-spinner--".concat(a), l),
      "data-ds-component": "DS-Spinner",
      role: "status",
      "aria-label": r,
      style: {
        "--spinner-color": o === "currentColor" ? "currentColor" : s
      }
    }, e.createElement("svg", {
      "aria-hidden": "true",
      fill: "currentColor",
      viewBox: m
    }, e.createElement("circle", {
      className: "olx-spinner__animated",
      fill: "none",
      cx: n,
      cy: n,
      r: _,
      strokeWidth: i
    })));
  };
export { E as Spinner };